export default __webpack_public_path__ + "static/media/open-in-new-tab-white.530b21e7.svg";